import { Inject, Component, Optional, ViewChild, ChangeDetectorRef } from "@angular/core";
import { BaseActionBoxComponent } from "../..";
import { GraphicsPanel, ConfGraphicsValue, ConfGraphicsRequest, GraphicsDisplayStyle, ConfUIItem } from "../../models";
import { GraphicsPopupComponent } from "../../../configurator/popups";

// MOVE ConfiguratorController TO PAGES/SHARED/PROVIDERS
import { ConfDataController } from "../../providers/configurationData";
import { ConfiguratorStore, ConfPageSessionService } from "../../../configurator/providers";
import { ProductDataStore } from "../../providers/productData";
import { ModelFactory, RouteNames } from "../../providers";
import { PageStore } from "../../providers/page/pageStore";
import { ImageSets } from "../../../../shared/utils";
import { VisualObjectHelper } from "../../../configurator/parameters/shared/visualObjectHelper";
//import { window } from "d3";

@Component({
  selector: 'graphics-action-box',
  templateUrl: './graphicsActionBoxComponent.html',
  providers: [VisualObjectHelper]
})
export class GraphicsActionBoxComponent extends BaseActionBoxComponent {

  public graphicPanels: Array<GraphicsPanel>;

  @ViewChild(GraphicsPopupComponent)
  public graphicsPopup: GraphicsPopupComponent;

  public imageSet: string;

  constructor(
    @Optional() @Inject(ConfiguratorStore) configuratorStore: ConfiguratorStore,
    @Inject(ProductDataStore) public productStore: ProductDataStore,
    @Inject(ConfDataController) public configuratorController: ConfDataController,
    @Inject(ConfPageSessionService) public confPageSessionService: ConfPageSessionService,
    @Inject(ChangeDetectorRef) public cdr: ChangeDetectorRef,
    public modelFactory: ModelFactory,
    public pageStore: PageStore
  ) {
    super(configuratorStore);
  }

  public shouldBeVisible(): boolean {
    return this.graphicPanels.length > 0;
  }

  public setup(): void {

    this.imageSet = this.getImageSet(ImageSets.SummaryActionDetail);

    this.graphicPanels = [];

    if (!this.conf)
      return;

    if (this.pageStore.activeRouteName == RouteNames.Summary) {
      const uiItems: Array<ConfUIItem> = this.confPageSessionService.activeConfiguration.uiItems.filter(uiItem => uiItem.itemName === GraphicsPanel.name).toArray();

      uiItems.forEach(x => {

        // Note! Grouping is not supported yet for action boxes. We need more work on this part.
        const visualObject = this.productStore.getEntity(x.id);
        // We only care about render graphics, popup graphic will be shown in side menu.
        if (visualObject instanceof GraphicsPanel && (visualObject.displayStyle === GraphicsDisplayStyle.Popup || visualObject.displayStyle === GraphicsDisplayStyle.OpenInDownloadFormat)) {
          // TODO check if visible, this code is copied from PanelVisibilityService, needs to be combined or something.
          if (!visualObject.hideEmptyPanel || this.configuratorStore.getConfDataEntity<ConfGraphicsValue>(this.configurationId, this.confSessionId, visualObject.visualObjectId).svg)
            this.graphicPanels.push(visualObject);
        }
      });
    }
    else if (this.pageStore.activeRouteName == RouteNames.Start) {

      this.configuratorStore.onConfigurationChange(this.configurationId, this.confSessionId, (conf) => {

        if (!conf.graphicsValues)
          return;

        this.conf.graphicsValues.forEach(x => {
          let graphicValue = this.configuratorStore.getConfDataEntity<ConfGraphicsValue>(this.configurationId, this.confSessionId, x);

          if (graphicValue && graphicValue.graphicsPanel)
            this.graphicPanels.push(graphicValue.graphicsPanel);
        });

        this.visible = this.graphicPanels.length > 0;
      }).unsubscribeOn(this.unsubscribeSubject);
    }
  }

  public openPopup(panel: GraphicsPanel) {

    if (panel.displayStyle == GraphicsDisplayStyle.OpenInDownloadFormat) {
      let model: ConfGraphicsRequest = this.modelFactory.createAny(ConfGraphicsRequest.name) as any;
      model.client = this.pageStore.getActiveClientType();
      model.fileType = "SVG";
      model.configurationId = this.configurationId;
      model.confSessionId = this.confSessionId;
      model.graphicsPanelId = panel.visualObjectId;

      window.open(this.configuratorController.getConfigurationGraphicViewerUrl(model));
    }
    else
      this.graphicsPopup.show(panel, this.configurationId, this.confSessionId);

    return false;
  }

}